export default __webpack_public_path__ + "static/media/point.8c416178.svg";